import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-accurate-interest',
  templateUrl: './accurate-interest.component.html',
  styleUrls: ['./accurate-interest.component.css']
})
export class AccurateInterestComponent implements OnInit {

  //display list debt data
  debt_all: any; //ข้อมูลทั้งหมดของลูกหนี้ที่ status == Enable
  debt_view: any; //ข้อมูลลูกหนี้ที่แสดง
  search = {
    debt_name: ''
  }
  debt_name = [] as any; //ชื่อลูกหนี้ทั้งหมด เอาไว้ search
  display_list: boolean = true;
  mlr:any;
  page = 1;
  count = 0;
  tableSize = 5;

  //display calculate interest
  debt_select: any;  ///
  debt_detail: any;
  maximized: boolean = false;
  cal_data = [] as any;
  sum_calData = {principle: 0, interest:0, sum:0}
  accrued_interest : any = []

  arr_interest = [] as any ///
  arr_finalDebt = [] as any
  d_interest = 7.5  ///ดอกเบี้ยผิดนัดชำระ
  debt_pay = [] as any ///

  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    document.getElementById('accurateinterest')!.classList.toggle("active");

    this.getDataDebt();
  }

  ngOnDestroy(){
    document.getElementById('accurateinterest')!.classList.toggle("active");
  }

  //display list debt data
  async getDataDebt() {
    await this.services.get('m_receivabledetail').then((res: any) => {
      this.debt_all = res.filter((res: any) => {
        res.principle = JSON.parse(res.principle)
        return res.status.match("Enable")
      })
    })
    this.debt_all = this.debt_all.filter((e: any) => {
      e.debt_id = Number(e.debt_id)
      return e.type_money.match("เงินให้กู้ยืม")
    })
    this.debt_all = this.debt_all.sort((a:any,b:any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))

    this.debt_view = this.debt_all
    this.debt_view.forEach(async (res: any, i: any) => {
      res.index = i + 1;
    });
    //ดูช่วงการใช้ MLR
    await this.services.get('m_calconditions').then((res: any) => {
      res = res.filter((res:any)=>{
        return res.status.match("Enable")
      })
      res = res.sort((a:any,b:any) => (a.date_used < b.date_used) ? -1 : ((b.date_used < a.date_used) ? 1 : 0))
      for(let i=0 ; i<res.length ; i++){
        if(i!=res.length-1){
          res[i].use = `${this.dateThaiFormat(res[i].date_used)} - ${this.dateThaiFormat(new DatePipe('en-US').transform(new Date(new Date(new Date(res[i+1].date_used).getFullYear(), new Date(res[i+1].date_used).getMonth(), new Date(res[i+1].date_used).getDate() - 1)), 'yyyy-MM-dd'))}`
        }else {
          res[i].use = `${this.dateThaiFormat(res[i].date_used)} - ปัจจุบัน`
        }
      }
      this.mlr = res.reverse()
    })
  }
  //search data debt
  onSearch() {
    this.debt_view = []
    this.debt_view = this.debt_all.filter((res: any) => {
      return res.project_name.match(this.search.debt_name)
    })
    this.debt_view.forEach(async (res: any, i: any) => {
      res.index = i + 1;
    });
  }
  onClickDetail(data: any) {
    this.display_list = false
    
    if(typeof(data.date_approve)=='string'){
      data.date_approve = JSON.parse(data.date_approve)
    }
    if(typeof(data.debt_pay)=='string'){
      data.debt_pay = JSON.parse(data.debt_pay)
    }
    if(typeof(data.duration)=='string'){
      data.duration = JSON.parse(data.duration)
    }
    if(typeof(data.notify_amount)=='string'){
      data.notify_amount = JSON.parse(data.notify_amount)
    }
    this.debt_select = data;
    if (this.debt_select.date_agree != '') {
      this.debt_select.date_agree_th = this.dateThaiFormat(this.debt_select.date_agree)
    }
    if (this.debt_select.debt_pay != '') {
      this.debt_select.debt_pay_th = this.dateThaiFormat(this.debt_select.debt_pay)
      const date = this.debt_select.debt_pay_th.split(' ');
      this.debt_select.debt_pay_th = `${date[0]} ${date[1]}`
    }
    if (this.debt_select.first_pay != '') {
      this.debt_select.first_pay_th = this.dateThaiFormat(this.debt_select.first_pay)
    }
    if (this.debt_select.final_pay != '') {
      this.debt_select.final_pay_th = this.dateThaiFormat(this.debt_select.final_pay)
    }
    if (this.debt_select.notify_amount != '') {
      this.debt_select.notify_amount_th = this.dateThaiFormat(this.debt_select.notify_amount)
      const date = this.debt_select.notify_amount_th.split(' ');
      this.debt_select.notify_amount_th = `${date[0]} ${date[1]}`
    }
    this.calculate();
  }

  //display calculate interest
  onClickBack() {
    // document.querySelector('#list')!.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.display_list = true
    this.cal_data = [];
    this.arr_finalDebt = []
    this.accrued_interest = [];
    this.sum_calData = {principle: 0, interest:0, sum:0}
    this.debt_select = undefined
  }
  async calculate() {
    let arr_interest = this.debt_select.principle  //ข้อมูลการชำระเงินต้น
    
    if (arr_interest.length > 0) {
      var numOfDay: any //จำนวนวันในแต่ละงวด
      var first_day: any
      var second_day: any
      var debt_day: any //วันครบกำหนดจ่าย
      var principle: any //จำนวนเงินต้นที่จ่ายแต่ละงวด
      let data_mlr: any; // อัตราดอกเบี้ยทั้งหมด
      let mlr: any //ดอกเบี้ย MLR
      let different_mlr: any //ส่วนต่างMLR
      var day_in_year: any //จำนวนวันในปี
      var interest: any //ดอกเบี้ย
      var sum_int: any = 0 //ผลรวมดอกเบี้ย

      var loan_ori: any //จำนวนเงินต้นทั้งหมด
      var date_start: any
      const data = [] as any
      let interest_cal = [] as any

      let arr_cal_interrest = [] as any
      
      await this.services.get('m_calconditions').then((res: any) => {
        data_mlr = res.sort((a: any, b: any) => (new Date(a.date_used) < new Date(b.date_used)) ? -1 : ((new Date(b.date_used) < new Date(a.date_used)) ? 1 : 0))
      })
      switch (this.debt_select.manager_type) {
        case 'สมาคม (โครงการในพื้นที่เป้าหมาย)': {
          different_mlr = 3.5
          break;
        }
        case 'สมาคม (โครงการนอกพื้นที่เป้าหมาย)': {
          different_mlr = 2
          break;
        }
        case 'องค์กรปกครองส่วนท้องถิ่น': {
          different_mlr = 3
          break;
        }
        case 'การเคหะแห่งชาติ': {
          different_mlr = 3
          break;
        }
        case 'กรมโยธาธิการและผังเมือง': {
          different_mlr = 3
          break;
        }
        case 'หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน': {
          different_mlr = 2
          break;
        }
        case 'หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง': {
          different_mlr = 2
          break;
        }
        default: {
          //statements; 
          break;
        }
      }
      //วันที่เริ่มคิดดอกเบี้ยและจำนวนเงิน งวดแรกที่จ่าย
      for (let j = 0; j < this.debt_select.notify_amount.length; j++) {
        if (j == 0) {
          date_start = this.debt_select.notify_amount[j].date
          loan_ori = this.debt_select.notify_amount[j].amount
        }
      }
      //คำนวนดอกเบี้ยค้างรับ
      let diff_year = (new Date(arr_interest[arr_interest.length-1].date_pay).getFullYear()) - (new Date(date_start).getFullYear()) //หาความต่างของปีเริ่มจ่ายกับปีสิ้นสุด
      if(new Date(arr_interest[arr_interest.length-1].date_pay).getMonth()>8){ //ถ้าปีสิ้นสุด เดือนมากกว่ากันยา ให้+1 ปีดอกเบี้ยคงค้าง
        diff_year += 1
      }
      for (let index = 0; index < diff_year; index++) {  //เพิ่มปีตาม ปีที่ต่าง จากปีที่จ่าย
        if (index>=this.debt_select.gp_interest) {  //เช็คปีที่ปลอดดอกเบี้ย
          let year = (new Date(date_start).getFullYear()) + Number(index)
          let data_interest = arr_interest.filter((f: any) => { //หาวันครบกำหนดชำระ ที่มีปีตรงกับปีที่วนลูป
            return new Date(f.date_pay).getFullYear() == year
          })
          if (data_interest.length == 0) {  //เงื่อนไข มีข้อมูลครบกำหนดชำระ ตรงกับปี
            this.accrued_interest.push({
              year: this.dateThaiFormat(new DatePipe('en-US').transform(new Date(new Date(year, 8, 30)), 'yyyy-MM-dd')),
              total: 0,
              start: date_start,  //วันเริ่มคิดดอกค้างรับ คือ วันที่เริ่มจ่ายเงินงวดแรก
              end: new Date(new Date(year, 9, 1))
            })
          } else {  //เงื่อนไข ไม่มีข้อมูลครบกำหนดชำระ ตรงกับปี
            let date_start_debt = new DatePipe('en-US').transform(new Date((new Date(data_interest[0].date_debt).setDate(new Date(data_interest[0].date_debt).getDate() + 1))), 'yyyy-MM-dd') 
            // ให้วันเริ่มคิดดอกค้างรับ เป็นค่าแรกของข้อมูลครบกำหนดชำระที่ตรงกับปี
            if (index == 0) {  //ถ้าเป็นข้อมูลแรก ให้วันเริ่มคิดดอกค้างรับ คือ วันที่เริ่มจ่ายเงินงวดแรก
              date_start_debt = date_start
            }
            data_interest.forEach((e: any, i: any) => { //loop หาค่าวันเริ่มคิดดอกเบียค้างรับ
              if (year == new Date(e.date_debt).getFullYear()) {//ถ้าวันเริ่มคิดดอกค้างรับ เป็นปีเดียวกับ ปีที่วน
                if ((new Date(e.date_debt) < new Date(year, 9, 1))) {  //check case วันที่ครบกำหนดคิดดอกเบี้ย < 30 กันยา
                  date_start_debt = new DatePipe('en-US').transform(new Date((new Date(e.date_debt).setDate(new Date(e.date_debt).getDate() + 1))), 'yyyy-MM-dd')
                  // แทนที่วันที่ใหม่ ที่น้อยกว่า 30 กันยา ของปีเดียวกัน
                }
              }
            });
            this.accrued_interest.push({
              year: this.dateThaiFormat(new DatePipe('en-US').transform(new Date(new Date(year, 8, 30)), 'yyyy-MM-dd')),
              total: 0,
              start: date_start_debt,
              end: new Date(new Date(year, 9, 1))
            })
          }
        }
      }
      
      for (let i = 0; i < arr_interest.length; i++) {
        let first_duration: any;
        let last_duration: any;
        let year_budget = 0  //หาปีงบประมาณจากวันที่ครบกำหนดชำระ
        if(arr_interest[i].date_pay){  //หาปีงบประมาณจากวันที่ครบกำหนดชำระ
          year_budget= new Date(arr_interest[i].date_pay).getFullYear()
          year_budget = Number(year_budget) + 543
          let month_budget = new Date(arr_interest[i].date_pay).getMonth()+1
          if(month_budget>9){
            year_budget +=1
          }
        }

        if (i >= this.debt_select.gp_interest) { //พิจารณางวดที่ไม่ปลอดดอกเบี้ย
          //คำนวนจำนวนวันในแต่ละงวด
          if (i == 0) {
            first_day = date_start //วันแรกที่จ่ายเงินงวดแรก เป็นวันเริ่มต้นคิดดอก
            second_day = arr_interest[i].date_debt //วันครบกำหนดคิดดอกเบี้ยงวดปัจจุบัน
            debt_day = arr_interest[i].date_pay
            principle = arr_interest[i].principle
          } else {
            var end = new DatePipe('en-US').transform(new Date((new Date(arr_interest[i - 1].date_debt).setDate(new Date(arr_interest[i - 1].date_debt).getDate() + 1))), 'yyyy-MM-dd')
            first_day = end //วันครบกำหนดคิดดอกเบี้ยงวดก่อนหน้า +1 เป็นวันเริ่มต้นคิดดอก
            second_day = arr_interest[i].date_debt //วันครบกำหนดคิดดอกเบี้ยงวดปัจจุบัน
            debt_day = arr_interest[i - 1].date_pay
            principle = arr_interest[i - 1].principle
          }
          sum_int = 0
          numOfDay = this.difference_day(new Date(first_day!), new Date(second_day!)) + 1

          //คำนวณดอกเบี้ยในแต่ละงวด
          for (let x = 1; x <= numOfDay; x++) {
            if (x == 1) {//หาวันที่การคิดดอกเบี้ย
              first_duration = first_day
            }
            if (x == numOfDay) {
              last_duration = second_day
            }

            if (x == 1 && i == 0) { //check date
              first_day = new DatePipe('en-US').transform(new Date(date_start!), 'yyyy-MM-dd')
              second_day = new DatePipe('en-US').transform(new Date((new Date(first_day).setDate(new Date(first_day).getDate() + 1))), 'yyyy-MM-dd')
            } else if (x == 1) {
              first_day = first_day
              second_day = new DatePipe('en-US').transform(new Date((new Date(first_day).setDate(new Date(first_day).getDate() + 1))), 'yyyy-MM-dd')
            } else {
              first_day = second_day
              second_day = new DatePipe('en-US').transform(new Date(new Date(first_day).getFullYear(), new Date(first_day).getMonth(), new Date(first_day).getDate() + 1), 'yyyy-MM-dd');
            }

            //check mlr
            data_mlr.forEach(async (data: any, i: any) => {
              if (i == data_mlr.length - 1) {
                if (new Date(first_day!) >= new Date(data.date_used)) {
                  mlr = Number(data.interest)
                }
              } else {
                if (new Date(first_day!) >= new Date(data.date_used) && new Date(first_day!) <= new Date(data_mlr[i + 1].date_used)) {
                  mlr = Number(data.interest)
                }
              }
            });
            for (let y = 0; y < this.debt_select.notify_amount.length; y++) { //check เงินต้นงวดต่างๆ *กรณีที่มีมากกว่า1งวด
              if (y > 0 && first_day == this.debt_select.notify_amount[y].date) {
                loan_ori = Number(loan_ori) + Number(this.debt_select.notify_amount[y].amount) //เงินต้นทั้งหมด
              }
            }

            if (first_day == debt_day) { //check pay debt วันที่ครบกำหนดชำระเงิน หากครบแล้วจะลดต้นตามจ่ายจริง
              loan_ori = Number(loan_ori) - Number(principle)
            }
            //หาจำนวนวันในปีที่คิดดอก
            day_in_year = await this.days_of_a_year(Number(new DatePipe('en-US').transform(new Date(first_day), 'yyyy')!))
            //คำนวณดอกเบี้ย
            interest = await Number(((Number(loan_ori) * ((Number(mlr) - Number(different_mlr)) / 100)) * (this.difference_day(new Date(first_day!), new Date(second_day!)) / day_in_year)).toFixed(11))
 
            sum_int += Number((interest).toFixed(11))
            sum_int = Number((sum_int).toFixed(10))
            arr_cal_interrest.push({date:first_day, interest:interest})
          }
          data.push({
            year: i + 1,
            int: Number(sum_int.toFixed(2)),
            year_ac: year_budget,
            duration: `${this.dateThaiFormat(first_duration)} - ${this.dateThaiFormat(last_duration)}`
          })
        }else{
          data.push({
            year: i + 1,
            int: 0,
            year_ac: year_budget,
            duration: ``
          })
        }
      }
      interest_cal = data  //ข้อมูลที่คำนวน
      arr_interest.forEach((e: any, i: any) => { //เทียบข้อมูลที่คำนวนใส่ข้อมูลเดิม
        e.date_debtTH = this.dateThaiFormat(e.date_debt)
        e.date_payTH = this.dateThaiFormat(e.date_pay)
        interest_cal.forEach((el: any, j: any) => {
          if (e.year == el.year) {
            e.interest = el.int
            e.sum = Number(e.principle) + Number(e.interest)
            e.duration = el.duration
            e.year_ac = el.year_ac
          }
        });
      });
      this.arr_interest = arr_interest
      await this.cal_actualPay()
      await this.cal_accrual_interest(arr_cal_interrest)
    }
  }
  async cal_actualPay(){
    let arr_finalDebt =[] as any //array เก็บการคำนวน จ่ายดอกเบี้ยและค่าปรับทั้งหมด
    await this.services.get("m_receivabletable").then((res: any) => {
      this.debt_pay = res.filter((data: any) => {
        return data.status.toLowerCase().match('enable') && data.project_key.match(this.debt_select.project_key)
      })
    });
    this.debt_pay = this.debt_pay.sort((a: any, b: any) => (a.id < b.id) ? -1 : ((b.id < a.id) ? 1 : 0))
    let arr_debt = this.debt_pay.filter((d:any)=>{ //หาข้อมูลการชำระหนี้
      return d.debt_paydate
    })
    let arr_errDebt = arr_debt.filter((f:any)=>{
      return f.err_interest == 'true'
    })
    for await (const [i, e] of this.arr_interest.entries()) {
      if (arr_debt.length > 0) { //หาวันที่จ่ายจริง
        let pay_actual = arr_debt.find((d: any) => {
          return (d.debt_installment).split(' ')[1] == e.year
        })
        if (pay_actual) {//มีวันที่จ่ายจริง
          e.date_actualPay = pay_actual.debt_paydate
          e.date_actualPayTH = this.dateThaiFormat(pay_actual.debt_paydate)
          e.remark = pay_actual.remark

          arr_finalDebt.push(e)
          if (new Date(pay_actual.debt_paydate) > new Date(e.date_pay)) { //คำนวนค่าปรับ
            let pay_errInterest = arr_errDebt.find((f: any) => {
              return (f.debt_installment).split(' ')[1] == e.year
            })
            let pay_debt = ''
            let pay_debtTH = ''
            let pay_remark = ''

            if (pay_errInterest) { //จ่ายค่าปรับ
              pay_debt = pay_errInterest.debt_paydate
              pay_debtTH = this.dateThaiFormat(pay_errInterest.debt_paydate)
              pay_remark = pay_errInterest.remark
            }
            let err_interest = (Number(this.debt_select?.amount_receive) * (this.d_interest / 100)) * ((this.difference_day(new Date(e.date_pay), new Date(e.date_actualPay))-1) / this.days_of_a_year(new Date(e.date_pay).getFullYear()))
            let err_data = {
              year: '',
              date_debt: " ",
              date_debtTH: " ",
              date_pay: " ",
              date_payTH: " ",
              principle: 0,
              remain: "",
              interest: err_interest,
              sum: err_interest,
              date_actualPay: pay_debt,
              date_actualPayTH: pay_debtTH,
              default_interest: "",
              year_ac: "1",
              duration: `${(this.difference_day(new Date(e.date_pay!), new Date(pay_actual.debt_paydate)) - 1)} วัน`,
              remark: pay_remark
            }
            arr_finalDebt.push(err_data)
          }
        } else {//ไม่มีวันที่จ่ายจริง
          e.date_actualPay = ''
          e.date_actualPayTH = ''
          e.remark = ''
          arr_finalDebt.push(e)
        }
      }else{
        arr_finalDebt.push(e)
      }
    }
    this.arr_finalDebt = arr_finalDebt
    this.sum_calData.principle = this.arr_finalDebt.reduce((a: any, b: any) => +a + +Number(b.principle), 0);
    this.sum_calData.interest = this.arr_finalDebt.reduce((a: any, b: any) => +a + +Number(b.interest), 0);
    this.sum_calData.sum = this.arr_finalDebt.reduce((a: any, b: any) => +a + +Number(b.sum), 0);
  }
  async cal_accrual_interest(arr_cal_interrest:any){ //คำนวนดอกเบี้ยค้างรับ
    for (const int of this.accrued_interest) {
      let arr_interest = arr_cal_interrest.filter((f:any)=>{
        return new Date(f.date) >= new Date(int.start) && new Date(f.date) < new Date(int.end)
      })
      let sum_accrual_interest = arr_interest.reduce((a:any, b:any) => +a + +Number(b.interest), 0);
      int.total = sum_accrual_interest
    }
  }
  //full page table
  maximizeorMinimize(table: any, btn: any) {
    this.services.maximizeorMinimize(table, btn, this.maximized)
    this.maximized = this.services.switchMaximize(this.maximized);
  }
  // เปลี่ยนวันที่เป็นภาษาไทย
  dateThaiFormat(date: any) {
    if(date){
      return date = new Date(date).toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    }else{
      return ''
    }
  }
  //นับจำนวนวันในปี
  days_of_a_year(year: number) {
    return this.isLeapYear(year) ? 366 : 365;
  }
  isLeapYear(year: number) {
    return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
  }
  //คำนวณจำนวนวันที่ต่าง
  difference_day(day1: any, day2: any) {
    var difference_In_Time = day2.getTime() - day1.getTime();
    var difference_In_Days = (difference_In_Time / (1000 * 3600 * 24));
    return difference_In_Days
  }
  //ปัดทศนิยม
  mathRound(num: number) {
    return Math.round((num + Number.EPSILON) * 100) / 100
  }
  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
}
